import {StockInDetail} from "./stock-in-detail.component";

export default StockInDetail;
